/* eslint-disable @typescript-eslint/no-unnecessary-type-parameters */
import { addDays, addSeconds, startOfDay } from 'date-fns';
import {
  PlainNumberRangeInterface,
  PlainRangeInterface,
  RangeInterface,
} from '../models/range.interface';

export function tsRangeMin<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = StartBoundary extends 'infinite' ? Date | null : Date,
>(
  range: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
): ReturnType {
  if (range.start === null) {
    return null as ReturnType;
  }
  const start = new Date(range.start);
  if (range.inclusiveStart) {
    return start as ReturnType;
  }
  return addSeconds(start, 1) as ReturnType;
}

export function dateRangeMin<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = StartBoundary extends 'infinite' ? Date | null : Date,
>(
  range: PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>,
): ReturnType {
  if (range.start === null) {
    return null as ReturnType;
  }
  const start = new Date(range.start);
  if (range.inclusiveStart) {
    return startOfDay(start) as ReturnType;
  }
  return startOfDay(addDays(start, 1)) as ReturnType;
}

export function intRangeMin<
  StartBoundary extends 'finite' | 'infinite' = 'finite',
  EndBoundary extends 'finite' | 'infinite' = 'finite',
  PlainType extends string | number = string,
  PlainStartType extends PlainType | null = StartBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  PlainEndType extends PlainType | null = EndBoundary extends 'finite'
    ? PlainType
    : PlainType | null,
  ReturnType = StartBoundary extends 'infinite' ? number | null : number,
>(
  range:
    | PlainRangeInterface<StartBoundary, EndBoundary, PlainType, PlainStartType, PlainEndType>
    | RangeInterface
    | PlainNumberRangeInterface<
        StartBoundary,
        EndBoundary,
        PlainType,
        PlainStartType,
        PlainEndType
      >,
): ReturnType {
  if (range.start === null) {
    return null as ReturnType;
  }
  const start: number = typeof range.start === 'string' ? parseInt(range.start, 10) : range.start;
  if (range.inclusiveStart) {
    return start as ReturnType;
  }

  return (start + 1) as ReturnType;
}
